'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.catchAndRethrowNetworkError = catchAndRethrowNetworkError;
exports.ravenDataCallback = ravenDataCallback;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Network errors to isolate into groups regardless of URL
var ISOLATED_NETWORK_CODES = ['ABORT', 'NETWORKERROR', 'TIMEOUT', '401'];

// taken from https://stackoverflow.com/a/3809435
var uriRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

function getAllAvailableLocales(localesMap) {
  // localeKeys are usually 'parent' locales like 'en' and
  // availableLocale contains an array of variants like
  // ['en_us', 'en_ie', etc]
  var localeKeys = Object.keys(localesMap);
  return localeKeys.reduce(function (allLocales, localeKey) {
    var availableLocales = localesMap[localeKey].availableLocale;
    return [].concat(_toConsumableArray(allLocales), _toConsumableArray(availableLocales));
  }, localeKeys);
}

// get all possible locale codes to remove them from JS errors
function getAllLocaleRegex() {
  var allLocales = void 0;

  if (_I18n2.default) {
    // get the fully supported locales
    var baseLocales = getAllAvailableLocales(_I18n2.default.baseLocales);
    // get unsupported but recognised locales
    var publicLocales = getAllAvailableLocales(_I18n2.default.publicLocales);
    allLocales = (0, _immutable.Set)([].concat(_toConsumableArray(baseLocales), _toConsumableArray(publicLocales)));
  } else {
    // fallback if I18n failed to load
    allLocales = (0, _immutable.Set)([(0, _getLang2.default)()]);
  }

  // output will generally look like a chain looking to remove
  // ['en', "en", (en), 'fr', "fr", (fr), ...]
  var allLocaleRegexStr = Array.from(allLocales).map(function (lang) {
    return '\'' + lang + '\'|"' + lang + '"|[(]' + lang + '[)]';
  }).join('|');

  return new RegExp(allLocaleRegexStr, 'g');
}

var ALL_LOCALE_REGEX = getAllLocaleRegex();

function stripPortalId(str) {
  var portalId = _hubspot2.default.get();

  if (portalId) {
    var portalIdRegex = new RegExp(portalId, 'g');
    return str.replace(portalIdRegex, '<portal_id>');
  }

  return str;
}

function stripQueryParams(url) {
  return url.replace(/\?.*$/, '');
}

function cleanseUrl(url) {
  return stripPortalId(stripQueryParams(url));
}

function stripLocale(str) {
  return str.replace(ALL_LOCALE_REGEX, '<user_lang>');
}

function splitIntoLines(str) {
  return str.split(/\r?\n/g);
}

function containsUri(str) {
  return uriRegex.test(str);
}

function parseUri(str) {
  var matches = uriRegex.exec(str);
  return matches && matches[0];
}

// taken from https://stackoverflow.com/a/1981366
function stripRepeatedWhitespace(str) {
  return str.replace(/\s\s+/g, ' ');
}

/**
 * We want to avoid having multiple sentries for the same error but we still want to track it.
 * The problem is that every request has the portalId in the query string, which results in a
 * different error message, thus a different error.
 * What we are doing here is manually capturing an error with Sentry and adding a fingerprint.
 * Sentry will group all the errors with the same fingerprint regardless of the actual error.
 * The fingerprint for each error network is: url (without query string) + error code
 */
function catchAndRethrowNetworkError(error) {
  var code = error.errorCode || error.status;

  if (code && error.options && error.options.url) {
    var cleansedUrl = cleanseUrl(error.options.url);

    LOG.error(error, {
      fingerprint: ISOLATED_NETWORK_CODES.includes(code.toString()) ? [code] : [cleansedUrl, code],
      message: code + ': ' + cleansedUrl
    });
  }

  throw error;
}

function parseStacktracedError(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Unspecified Error';

  var _splitIntoLines = splitIntoLines(message),
      _splitIntoLines2 = _slicedToArray(_splitIntoLines, 1),
      firstLine = _splitIntoLines2[0];

  if (containsUri(firstLine)) {
    return 'Stacktraced Network Error: ' + cleanseUrl(parseUri(firstLine));
  } else {
    // Strip any meaningless characters or strings from JS exceptions.
    // We're removing locale codes here for JS errors where the UI attempts
    // to resolve a locale code key within a translation object or mentions
    // a locale code in file address; generally it is unimportant what
    // exact locale code it was when investigating
    return type + ': ' + stripLocale(stripRepeatedWhitespace(message));
  }
}

function ravenDataCallback(data, original) {
  // If the raven request already has a fingerprint, it has already been handled by
  // upstream from us by either our own network failure catches or by other FE tools
  // (e.g. usage tracking), and doesn't need to be assigned a fingerprint
  if (!data.fingerprint) {
    // The gist of the logic here is that we continuously try and find network errors through:
    // - `data` having an `exception` where a URL is mentioned in the first line
    // - `data` having a `request` property
    // - `data` having a `message` where a URL is mentioned in the first line
    // Otherwise we strip for excess whitespace and locales and treat as a JS error.

    var fingerprint = void 0;
    if (data.exception && data.exception.values && data.exception.values.length > 0) {
      var _data$exception$value = _slicedToArray(data.exception.values, 1),
          exception = _data$exception$value[0];

      fingerprint = [parseStacktracedError(exception.value, exception.type)];
    } else if (data.request && data.request.url) {
      // Strip portal ids and query params from requests...
      fingerprint = [cleanseUrl(data.request.url)];
    } else {
      fingerprint = [parseStacktracedError(data.message)];
    }
    // This will cause raven to ignore its default grouping behaviour and go solely
    // off our scrubbed error message
    data.fingerprint = fingerprint;
  }

  return original ? original(data) : data;
}